// extracted by mini-css-extract-plugin
module.exports = {"group":"Group_group__zgE4K","groupRow":"Group_groupRow__gsdLa","text":"Group_text__ivhJ2","tag":"Group_tag__tLKya","withBackground":"Group_withBackground__7JDrj"};